
const tableData = {}
import { useRouter } from "vue-router";
import { isNotEmpty } from "@/tools/utils";
const $router = useRouter();
/** 后端 ITEM/OMS 可能是 { data: [] }，QTable 需要数组 */
function normalizeTableRows(payload) {
    if (Array.isArray(payload)) return payload
    if (payload && Array.isArray(payload.data)) return payload.data
    return []
}

const sprItemColumns = [
    { name: 'POSNR', field: 'POSNR', label: '行号', align: 'left' },
    { name: 'MATNR', field: 'MATNR', label: '订货号', align: 'left' },
    { name: 'KWMENG', field: 'KWMENG', label: '数量', align: 'left' },
    { name: 'VRKME', field: 'VRKME', label: '单位', align: 'left' },
    { name: 'NETWRI', field: 'NETWRI', label: '不含税金额', align: 'left' },
    { name: 'EDATU', field: 'EDATU', label: '期望交货日期', align: 'left' },
]

const pageConfig = {
    errors: '',
    spr_loading: false,
    oms_loading: false,
    header: {},
    confirmDialogFun:null,
    item: {
        edit: true,
        selection: 'none',
        showSelection: false,
        data: [],
        columns: sprItemColumns,
        rowkey: 'id',
        loading: false,
        pagination: {
            rowsNumber: false
        },
        tools: {
            show_toolbar: true,
            title: '报价单数据',
            btns:[
                { index: 0, name: ['导出'], icon: 'fas fa-file-excel', check_lines: 0, on_click: [], sign: 'exportExcel', },
            ]
        },
    },
    oms: {
        edit: true,
        selection: 'none',
        showSelection: false,
        data: [],
        columns: sprItemColumns,
        rowkey: 'id',
        loading: false,
        pagination: {
            rowsNumber: false
        },
        tools: {
            show_toolbar: true,
            title: 'OMS数据',
            btns:[
                { index: 2, name: ['OMS数据匹配报价单数据'], icon: 'fas fa-clipboard-check', check_lines: 0, on_click: [], sign: 'matchOmsData', },
                { index: 1, name: ['生成采购订单'], icon: 'fas fa-tasks', check_lines: 0, on_click: [], sign: 'generatePurchaseOrderOms', },
                { index: 0, name: ['导出'], icon: 'fas fa-file-excel', check_lines: 0, on_click: [], sign: 'exportExcel', },
            ]
        },
    },
    formSet: {
        data: {
            body: [
                {
                    index: 0,
                    items: [
                        {
                            index: 1,
                            label: 'OMS单号',
                            labelWidth: 110,
                            showlabel: true,
                            name: 'oms_number',
                            value: '',
                            type: 'input',filled: false,outlined: true,minWidth: 160
                        },
                        {
                            index: 2,
                            label: '报价单号',
                            labelWidth: 110,
                            showlabel: true,
                            name: 'VBELN',
                            value: '',
                            type: 'input',filled: false,outlined: true,minWidth: 160,disable:true,
                        },
                        {
                            index: 3,
                            label: '报价日期',
                            labelWidth: 110,
                            showlabel: true,
                            name: 'ERDAT',
                            value: '',
                            type: 'input',filled: false,outlined: true,minWidth: 160,disable:true,
                        }
                        ,
                        {
                            index: 4,
                            label: '特折号',
                            labelWidth: 110,
                            showlabel: true,
                            name: 'BSTKD',
                            value: '',
                            type: 'input',filled: false,outlined: true,minWidth: 160,disable:true,
                        },
                        {
                            index: 5,
                            label: '三方协议号',
                            labelWidth: 110,
                            showlabel: true,
                            name: 'ZZPROM',
                            value: '',
                            type: 'input',filled: false,outlined: true,minWidth: 160,disable:true,
                        },
                        {
                            index: 6,
                            label: '报价单类型',
                            labelWidth: 110,
                            showlabel: true,
                            name: 'AUART',
                            value: '',
                            type: 'input',filled: false,outlined: true,minWidth: 160,disable:true,
                        },
                        {
                            index: 7,
                            label: '锁单/批准标志',
                            labelWidth: 110,
                            showlabel: true,
                            name: 'CMGST',
                            value: '',
                            type: 'input',filled: false,outlined: true,minWidth: 160,disable:true,
                        },
                        {
                            index: 8,
                            label: '不含税金额',
                            labelWidth: 110,
                            showlabel: true,
                            name: 'NETWRH',
                            value: '',
                            type: 'input',filled: false,outlined: true,minWidth: 160,disable:true,
                        },
                        {
                            index: 9,
                            label: '整单税额',
                            labelWidth: 110,
                            showlabel: true,
                            name: 'MWSTH',
                            value: '',
                            type: 'input',filled: false,outlined: true,minWidth: 160,disable:true,
                        },
                        {
                            index: 10,
                            label: '货币单位',
                            labelWidth: 110,
                            showlabel: true,
                            name: 'WAERK',
                            value: '',
                            type: 'input',filled: false,outlined: true,minWidth: 160,disable:true,
                        },
                        {
                            index: 11,
                            label: '预付款标志',
                            labelWidth: 110,
                            showlabel: true,
                            name: 'DPFLAG',
                            value: '',
                            type: 'input',filled: false,outlined: true,minWidth: 160,disable:true,
                        },
                        {
                            index: 12,
                            label: '消息类型',
                            labelWidth: 110,
                            showlabel: true,
                            name: 'MSGTYPE',
                            value: '',
                            type: 'input',filled: false,outlined: true,minWidth: 160,disable:true,
                        },
                        {
                            index: 13,
                            label: '消息文本',
                            labelWidth: 110,
                            showlabel: true,
                            name: 'MSGTXT',
                            value: '',
                            type: 'input',filled: false,outlined: true,minWidth: 160,disable:true,
                        }
                    ]
                }
            ]
        }
    }
}
const state = () => ({
    quotaionOms: Object.assign({}, tableData, pageConfig),
})

const mutations = {
    ['set-confirm-dialog-fun'](state, data){
        state.quotaionOms.confirmDialogFun = data
    },
    ['set-errors'](state, data){
        state.quotaionOms.errors = data
    },
    ['set-loading'](state, data){
        state.quotaionOms[data[0]] = data[1]
    },
    ['refreshTableHeight'](state, data){
        state.quotaionOms.item.height = (data-380) + 'px';
        state.quotaionOms.oms.height = (data-380) + 'px';
    },
    ['set-spr-data'](state, data){
        state.quotaionOms.formSet.data.body[0].items.forEach(item => {
            item.value = '';
        })
        state.quotaionOms.header = data.HEADER || {};
        const rows = normalizeTableRows(data.ITEM)
        state.quotaionOms.item.data = rows
        if (data.ITEM_COLUMNS){
            state.quotaionOms.item.columns = data.ITEM_COLUMNS
        }
        const headerRow = data.HEADER?.data
        if (headerRow) {
            state.quotaionOms.formSet.data.body[0].items.forEach(item => {
                if (item.name in headerRow) {
                    item.value = headerRow[item.name] ?? ''
                }
            })
        }
        if (data.oms?.ITEM){
            state.quotaionOms.oms.data = data.oms.ITEM
        }else{
            state.quotaionOms.oms.data = []
        }
        if (data.oms?.ITEM_COLUMNS){
            state.quotaionOms.oms.columns = data.oms.ITEM_COLUMNS
        }
        if(state.quotaionOms.header.data && state.quotaionOms.header.data['BSTKD_E']){
            state.quotaionOms.oms.tools.btns=[
                { index: 0, name: ['导出'], icon: 'fas fa-file-excel', check_lines: 0, on_click: [], sign: 'exportExcel', },
            ]
        }else{
            state.quotaionOms.oms.tools.btns=[
                { index: 2, name: ['OMS数据匹配报价单数据'], icon: 'fas fa-clipboard-check', check_lines: 0, on_click: [], sign: 'matchOmsData', },
                { index: 1, name: ['生成采购订单'], icon: 'fas fa-tasks', check_lines: 0, on_click: [], sign: 'generatePurchaseOrderOms', },
                { index: 0, name: ['导出'], icon: 'fas fa-file-excel', check_lines: 0, on_click: [], sign: 'exportExcel', },
            ]
        }
    },
    ['set-oms-data'](state, data){
        // const rows = normalizeTableRows(data.ITEM)
        // state.quotaionOms.oms.data = rows
        // if (data.ITEM_COLUMNS){
        //     state.quotaionOms.oms.columns = data.ITEM_COLUMNS
        // }
        if (data.oms){
            state.quotaionOms.oms.data = data.oms.ITEM
            state.quotaionOms.oms.data.forEach(item => {
                if(!isNotEmpty(item.qty)){
                    item.qty = 0;
                }
            })
            if (data.oms.ITEM_COLUMNS){
                state.quotaionOms.oms.columns = data.oms.ITEM_COLUMNS
            }
        }
        if (data.spr){
            state.quotaionOms.item.data = data.spr.ITEM;
            state.quotaionOms.item.data.forEach(item => {
                if(!isNotEmpty(item.qty)){
                    item.qty = 0;
                }
            })
            if (data.spr.ITEM_COLUMNS){
                state.quotaionOms.item.columns = data.spr.ITEM_COLUMNS
            }
        }
        
    },
    ['set-generate-success'](state, data){
        state.quotaionOms.header['BSTKD_E'] = data.BSTKD_E || ''
    }
}
const getters = {
    getErrors: state => state.quotaionOms.errors,
    getFormSet: state => state.quotaionOms.formSet,
    getSprHeaderData: state => state.quotaionOms.header,
    getSprItemData: state => state.quotaionOms.item,
    getOmsData: state => state.quotaionOms.oms,
    getSprLoading: state => state.quotaionOms.spr_loading,
    getOmsLoading: state => state.quotaionOms.oms_loading,
}
const actions = {
    async ['fetch-spr']({ state, dispatch, rootState ,commit}, payload) {
        if(state.quotaionOms.spr_loading) return;
        commit('set-loading',['spr_loading',true]);
        let msg = { command: "get_client__spr_data", message: payload, to: "client" }
        dispatch('channel/socket_send', msg, { root: true })
    },
    async ['return-spr-data']({ state, dispatch, rootState ,commit}, payload) {
        commit('set-loading',['spr_loading',false]);
        if (!payload.success) {
            dispatch('response/error-tip', {message: payload.msg}, {root: true})
        }
        if(payload.data){
            commit('set-spr-data',payload.data);
        }
    },
    async ['fetch-oms']({ state, dispatch, rootState ,commit}, payload) {
        // 判断OMS单号是否填写
        if(state.quotaionOms.formSet.data.body[0].items[0].value === ''){
            dispatch('response/error-tip', {message: 'OMS单号不能为空'}, {root: true})
            return;
        }
        if(state.quotaionOms.oms_loading) return;
        commit('set-errors','');
        commit('set-loading',['oms_loading',true]);
        let post_data = {
            VBELN: state.quotaionOms.formSet.data.body[0].items[1].value,
            oms_number: state.quotaionOms.formSet.data.body[0].items[0].value,
        }
        let msg = { command: "get_client__oms_data", message: post_data, to: "client" }
        dispatch('channel/socket_send', msg, { root: true })
    },
    async ['return-oms-data']({ state, dispatch, rootState ,commit}, payload) {
        commit('set-loading',['oms_loading',false]);
        if (!payload.success) {
            dispatch('response/error-tip', {message: payload.msg}, {root: true})
            commit('set-errors',payload.msg);
        }
        if(payload.data){
            commit('set-oms-data',payload.data);
        }
    },
    async ['generate']({ state, dispatch, rootState ,commit}, payload) {
        // 判断OMS单号是否填写
        if(state.quotaionOms.formSet.data.body[0].items[0].value === ''){
            dispatch('response/error-tip', {message: 'OMS单号不能为空'}, {root: true})
            return;
        }
        if(state.quotaionOms.oms_loading) return;
        commit('set-loading',['oms_loading',true]);
        commit('set-errors','');
        let post_data = {
            VBELN: state.quotaionOms.formSet.data.body[0].items[1].value,
            oms_number: state.quotaionOms.formSet.data.body[0].items[0].value,
        }
        if(payload.confirm){
            post_data.confirm = payload.confirm;
        }
        let msg = { command: "get_client__oms_generate", message: post_data, to: "client" }
        dispatch('channel/socket_send', msg, { root: true })
    },
    async ['return-generate-data']({ state, dispatch, rootState ,commit}, payload) {
        commit('set-loading',['oms_loading',false]);
        if(payload.confirm){
            state.quotaionOms.confirmDialogFun(payload);
            return;
        }
        if (!payload.success) {
            dispatch('response/error-tip', {message: payload.msg}, {root: true})
            commit('set-errors',payload.msg);
        }else{
            dispatch('response/success-tip', {message: payload.msg}, {root: true})
            // 刷新页面
            $router.go(0);

        }
        
    }
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}